var project = require('../../settings');
var utils = require('./modules/utils');
var Packery = require('packery');

/* Event Handlers  */
(function ($, $PB) {

    var ie = KMDGPB.builder.detectIE();
    var $header = $('header.site_header');
    var $main = $('.site-wrapper-x');
    var hasAdminBar = $("body").hasClass("admin-bar");

    var headerHeight = hasAdminBar ? Number($header.height()) + 32 : Number($header.height());

    var scroll_offset = -50;
    var scroll_speed = 1000;

    // Automatically equalize height on specified elements
    $(window).on("load", function () {
        var headerHeight = hasAdminBar ? Number($header.height()) + 32 : Number($header.height());

        //Tile Card layout
        utils.equalHeight('.tile-card__img', '.builder-layout');
        utils.equalHeight('.tile-card__content', '.builder-layout');
        utils.equalHeight('.tile-card__top', '.builder-layout');


        utils.equalHeight('.single_accordion__top_spacer', '.builder-layout');

        //Custom post type adjustments
        utils.equalHeight('.js-equal');
        $(window).trigger('resize').trigger('scroll');

        if (ie) {
            $('html').addClass('ms_ie').addClass('ms_ie' + ie);
        }

        setInterval(function () {
            jQuery(window).trigger('resize').trigger('scroll');
        }, 1000);
    });

    //Header top spacer
    $(window).on('load resize', function () {
        $header.addClass('fixed');
        $main.css('padding-top', $header.outerHeight());
    });


    $("#menu-wrapper").mmenu(
        {
            "navbars": [
                {
                    "position": "top",
                    "content": [
                        "searchfield"
                    ]
                }
            ],
            "extensions": [
                "pagedim-black",
                "theme-dark",
                "position-right"
            ],
            "searchfield": {
                "search": false,
            },
            classNames: {
                fixedElements: {
                    fixed: "fix",
                    sticky: "stick"
                }
            }
        }, {
            "searchfield": {
                "form": {
                    "method": 'GET',
                    "action": homeurl
                },
                "input": {
                    "name": 's'
                }
            }
        }
    );

    $(document).ready(function () {
        $('.builder-layout-full-width-masonry-grid .block-wrap').show();
        $('.builder-component-image-grid .block-wrap').show();
    });

    function commaSeparateNumber(val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return val;
    }

    $PB('.builder-component-ticker-counter').on('builderAnimationStart', function () {
        var $this = $(this),
            $number = $this.find('.single-counter .number'),
            countTo = $number.attr('data-count'),
            delay = $this.attr('data-animation-delay') * 1000;

        setTimeout(function () {
            $({
                countNum: 0
            }).animate({
                    countNum: countTo
                },

                {
                    duration: 4000,
                    easing: 'linear',
                    step: function () {
                        $number.text(commaSeparateNumber(Math.floor(this.countNum)));
                    },
                    complete: function () {
                        $number.text(commaSeparateNumber(this.countNum));
                    }
                }
            );
        }, delay);
    });

    //Updated Accordion JS
    $('.single_accordion .single_accordion__header').on('click', function () {
        var $column = $(this).parent();

        $column.toggleClass('open');
        $column.find('.single_accordion__inner').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });

    $('.image-container').on("hover", function () {
        $('.image-container')
    });

    function youtube_parser(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }

    $('a').each(function (i, el) {
        var url = $(el).attr("href");
        // use url.indexOf() to look for youtube embed urls
        // apply featherlight on those tags
        if (url) {
            if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)) {
                var id = youtube_parser(url);
                $(el).attr("data-featherlight", "iframe")
                    .attr("data-featherlight-iframe-width", "850")
                    .attr("data-featherlight-iframe-height", "468")
                    .attr("data-featherlight-iframe-frameborder", "0")
                    .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                    .attr("data-featherlight-iframe-allowfullscreen", "true")
                    .attr("href", "http://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1");

                $(el).featherlight();
            }
        }
    });

    //Search Bar open/close
    $('.search-bar .search-button').on('click', function () {
        $(this).parent().toggleClass('open');
    });

    //updated scroll to hash code
    if (location.hash) {
        $(window).on("load",function () {
            setTimeout(function () {
                utils.ScrollToHash(location.hash, null, scroll_offset, scroll_speed);

            }, 300);

        });
    }

    $(window).on('hashchange', function (e) {
        if (location.hash) {
            if (!utils.ScrollToHash(location.hash, null, scroll_offset, scroll_speed)) {
                e.preventDefault();
            }
        }
    });

})(jQuery, KMDGPB.jQuery);